import { get, post, del, put } from '@api/request';

export const getAppraisalSearchData = async (
  { appraisalService },
  authenticationToken,
  { payload },
) => {
  let data1 = await getPropertyData({ appraisalService }, authenticationToken, {
    payload,
  });
  return data1;
};

export const getPropertyMapConfigs = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/gis/savedmaps`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertPropertyMapConfig = async (
  { appraisalService },
  authenticationToken,
  { payload },
) => {
  const url = `${appraisalService}/appraisal/gis/savedmaps`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updatePropertyMapConfig = async (
  { appraisalService },
  authenticationToken,
  { mapID, payload },
) => {
  const url = `${appraisalService}/appraisal/gis/savedmap/${mapID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const deletePropertyMapConfig = async (
  { appraisalService },
  authenticationToken,
  { mapID },
) => {
  const url = `${appraisalService}/appraisal/gis/savedmap/${mapID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const getPropertySearchData = async (
  { appraisalService },
  authenticationToken,
  { payload },
) => {
  let data1 = await getPropertyData({ appraisalService }, authenticationToken, {
    payload,
  });
  let data2 = await getCurrentYear({ appraisalService }, authenticationToken);
  data1.results.currentYear = data2.results.year;
  return data1;
};

const getCurrentYear = async ({ appraisalService }, authenticationToken) => {
  const url = `${appraisalService}/appraisal/currentyear`;
  const { body } = await get(authenticationToken, url);
  return body;
};

const getPropertyData = async (
  { appraisalService },
  authenticationToken,
  { payload },
) => {
  const url = `${appraisalService}/appraisal/${payload.pid.value}/gis`;
  const { body } = await get(authenticationToken, url);
  return body;
};
